import React, { useState, useEffect } from 'react';
import { TextField } from '@mui/material';
import { useCurrency } from '../../context/CurrencyContext';

const CurrencyInput = ({
  value,
  onChange,
  onBlur,
  label,
  name,
  error,
  helperText,
  required = false,
  disabled = false,
  fullWidth = true,
  ...props
}) => {
  const { getCurrencySymbol } = useCurrency();
  const [displayValue, setDisplayValue] = useState('');

  useEffect(() => {
    if (value === '' || value === null || value === undefined) {
      setDisplayValue('');
    } else {
      const numValue = parseFloat(value);
      if (!isNaN(numValue)) {
        setDisplayValue(numValue.toFixed(2));
      }
    }
  }, [value]);

  const handleChange = (e) => {
    const input = e.target.value;
    
    // Allow empty input
    if (input === '') {
      setDisplayValue('');
      onChange(name, '');
      return;
    }

    // Remove non-numeric characters except decimal point and minus
    const cleaned = input.replace(/[^\d.-]/g, '');
    
    // Validate format
    const parts = cleaned.split('.');
    if (parts.length > 2) return; // Multiple decimal points
    
    // Limit to 2 decimal places
    if (parts[1] && parts[1].length > 2) {
      return;
    }

    setDisplayValue(cleaned);
    
    // Convert to number for parent component
    const numValue = parseFloat(cleaned);
    if (!isNaN(numValue)) {
      onChange(name, numValue);
    } else if (cleaned === '-' || cleaned === '.') {
      // Allow intermediate states
      onChange(name, cleaned);
    }
  };

  const handleBlur = (e) => {
    const numValue = parseFloat(displayValue);
    
    if (!isNaN(numValue)) {
      // Format to 2 decimal places on blur
      const formatted = numValue.toFixed(2);
      setDisplayValue(formatted);
      onChange(name, parseFloat(formatted));
    } else {
      setDisplayValue('');
      onChange(name, '');
    }
    
    if (onBlur) {
      onBlur(name);
    }
  };

  return (
    <TextField
      {...props}
      fullWidth={fullWidth}
      label={label}
      name={name}
      value={displayValue}
      onChange={handleChange}
      onBlur={handleBlur}
      error={!!error}
      helperText={error || helperText}
      required={required}
      disabled={disabled}
      InputProps={{
        startAdornment: getCurrencySymbol(),
        ...props.InputProps
      }}
      inputProps={{
        inputMode: 'decimal',
        pattern: '[0-9]*[.]?[0-9]{0,2}',
        ...props.inputProps
      }}
    />
  );
};

export default CurrencyInput;
